// extracted by mini-css-extract-plugin
module.exports = {"content-styling":"DropdownAdditionLabel_content-styling__1H_hB"};